
(function() {
  // Hi-Flame product image lightbox
  var overlay = null;

  function createOverlay() {
    overlay = document.createElement('div');
    overlay.id = 'hf-lightbox';
    overlay.style.cssText = [
      'display:none',
      'position:fixed',
      'inset:0',
      'z-index:99999',
      'background:rgba(0,0,0,0.92)',
      'align-items:center',
      'justify-content:center',
      'cursor:zoom-out'
    ].join(';');

    var img = document.createElement('img');
    img.id = 'hf-lightbox-img';
    img.style.cssText = [
      'max-width:90vw',
      'max-height:90vh',
      'object-fit:contain',
      'box-shadow:0 4px 40px rgba(0,0,0,0.6)',
      'cursor:default'
    ].join(';');
    img.addEventListener('click', function(e) { e.stopPropagation(); });

    var close = document.createElement('button');
    close.innerHTML = '&times;';
    close.setAttribute('aria-label', 'Close image');
    close.style.cssText = [
      'position:fixed',
      'top:20px',
      'right:28px',
      'background:none',
      'border:none',
      'color:#fff',
      'font-size:2.5rem',
      'line-height:1',
      'cursor:pointer',
      'padding:0',
      'z-index:100000'
    ].join(';');
    close.addEventListener('click', closeLightbox);

    overlay.appendChild(img);
    overlay.appendChild(close);
    overlay.addEventListener('click', closeLightbox);
    document.body.appendChild(overlay);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeLightbox();
    });
  }

  function openLightbox(src, alt) {
    if (!overlay) createOverlay();
    var img = document.getElementById('hf-lightbox-img');
    img.src = src;
    img.alt = alt || '';
    overlay.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox() {
    if (overlay) overlay.style.display = 'none';
    document.body.style.overflow = '';
  }

  function bindGallery() {
    var figures = document.querySelectorAll('.product-gallery--media[data-media-type="image"]');
    figures.forEach(function(figure) {
      if (figure.dataset.hfLightbox) return;
      figure.dataset.hfLightbox = '1';
      figure.style.cursor = 'zoom-in';
      figure.addEventListener('click', function() {
        var img = figure.querySelector('img');
        if (!img) return;
        // Get highest-res src available
        var src = img.src;
        // Try to get a larger version via srcset
        if (img.srcset) {
          var parts = img.srcset.split(',').map(function(s) { return s.trim().split(' '); });
          var best = parts.reduce(function(a, b) {
            var aw = parseInt(a[1]) || 0, bw = parseInt(b[1]) || 0;
            return bw > aw ? b : a;
          }, parts[0]);
          if (best && best[0]) src = best[0];
        }
        // Shopify URL: bump to 2048x for lightbox
        src = src.replace(/_(\d+)x(\d*)\./, '_2048x.');
        openLightbox(src, img.alt);
      });
    });
  }

  // Bind on load and re-bind when gallery switches images
  function init() {
    bindGallery();
    // Re-bind after gallery JS swaps figures
    var gallery = document.querySelector('[data-product-gallery]');
    if (gallery) {
      var observer = new MutationObserver(function() { bindGallery(); });
      observer.observe(gallery, { childList: true, subtree: true, attributes: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
